import React from 'react';

import { DropdownInput, DropdownContainer, DropdownWrapper } from './styles';

export default function Dropdown({
  value,
  options = [],
  onChange,
  fillAndCenter,
  width,
  disabled,
  justifyContent,
  margin,
}) {
  return (
    <DropdownWrapper justifyContent={justifyContent}>
      <DropdownContainer fillAndCenter={fillAndCenter} width={width} margin={margin}>
        <DropdownInput
          fillAndCenter={fillAndCenter}
          value={value}
          disabled={disabled}
          onChange={(e) => {
            let index = e.nativeEvent.target.selectedIndex;
            let label = e.nativeEvent.target[index].text;
            onChange({
              value: e.target.value,
              label,
            });
          }}
        >
          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </DropdownInput>
      </DropdownContainer>
    </DropdownWrapper>
  );
}
